import { getDataFromStorage } from '@/utilities/dataStorage';

export const isUserLogin = () => {
    if (typeof window !== 'undefined') {
        return !!getDataFromStorage('tokens', 'cookie');
    } else return null;
};
